import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { StatsReport } from '../../../interfaces/report';
import { SapiService } from '../../../services/sapi.service';
import { ToCodePipe } from '../../../pipes/toCode.pipe';
import { QueryParameter } from '../../../interfaces/queryString';
import { BbFilterConfiguration } from 'app/components/shared/bb-filters/bb-filters.component';
import { TranslateService } from '@ngx-translate/core';
import { FilterSet } from 'app/services/filter-set.service';

@Component({
	selector: 'lineitem-details-settings',
	templateUrl: './lineitem-details-settings.component.html',
	styleUrls: ['./lineitem-details-settings.component.scss']
})

export class LineitemDetailsSettingsComponent implements OnChanges {
	@Input() form: NgForm;
	@Input() lineitem: any;
	@Input() isNew = false;

	@Output() reportChanged: EventEmitter<StatsReport> = new EventEmitter<StatsReport>();

	conditionOptions: BbFilterConfiguration;
	codeNotUnique = false;
	allowSkipping: boolean;

	lineItemFilterset: FilterSet;

	subscriptions: Subscription = new Subscription();

	constructor(
		private sapiService: SapiService,
		private translate: TranslateService,
		private toCodePipe: ToCodePipe
	) {

		this.conditionOptions = {
			filters: [
				{
					property: 'type',
					label: this.translate.instant('DEVICE_TYPE'),
					type: 'singleSelect',
					options: [
						{ label: this.translate.instant('MOBILE'), value: 'mobile' },
						{ label: this.translate.instant('TABLET'), value: 'tablet' },
						{ label: this.translate.instant('DESKTOP'), value: 'desktop' },
					]
				}
			]
		};
	}

	ngOnChanges() {
		this.allowSkipping = (this.lineitem && this.lineitem.playout && this.lineitem.playout.skipOffset >= 0);
	}

	updateSkipOffset() {
		if (this.lineitem && this.lineitem.playout) {
			this.lineitem.playout.skipOffset = this.allowSkipping ? 5 : -1;
			if (this.form && this.form.form) {
				this.form.form.markAsDirty();
			}
		}
	}

	updateCode() {
		if (!this.lineitem.id) {
			this.lineitem.code = this.toCodePipe.transform(this.lineitem.title);
			this.onCodeUpdated(this.lineitem.code);
		}
	}

	onCodeUpdated(code) {
		// check uniqueness
		const qp: QueryParameter[] = [{
			name: 'q',
			values: [`code:"${code}"`]
		},
		{
			name: 'limit',
			values: ['0']
		}];
		this.sapiService.query('lineitem', qp).subscribe((result: any) => {
			if (result.count || result.totalAmount) {
				this.form.form.controls.code.setErrors({ 'not-unique': true });
				this.form.form.controls.code.markAsTouched();
				this.form.form.controls.code.markAsDirty();
			}
		});
	}
}
